<template>
  <div :loading="loading">
    <div class="fixedButton" style="margin: 10px 0">
      <vxe-button class="examineButton" @click="ReturnFun">返回</vxe-button>
      <vxe-button v-if="approveBtnType === '1'" class="examineButton" status="primary" @click="handleApprove(0)">发起审批</vxe-button>
      <vxe-button v-if="approveBtnType === '3'" class="examineButton" status="primary" @click="handleApprove(5)">重新发起审批</vxe-button>
      <vxe-button v-if="approveBtnType === '2'" class="examineButton" status="primary" @click="handleApprove(1)">同意</vxe-button>
      <vxe-button v-if="approveBtnType === '2'" class="examineButton" status="warning" @click="handleApprove(2)">退给上一审批人</vxe-button>
      <vxe-button v-if="approveBtnType === '2'" class="examineButton" status="danger" @click="handleApprove(3)">驳回</vxe-button>
      <vxe-button v-if="approveBtnType === '2'" class="examineButton" status="danger" @click="handleApprove(6)">不同意</vxe-button>
      <vxe-button v-if="approveBtnType === '2'" class="examineButton" @click="handleApprove(4)">转派</vxe-button>
    </div>
    <div class="CertificateReleaseApplicationBox scrollBars ActivityPlanReviewExamine" :style="`height:${$store.state.app.height - 70}px;`">
      <el-collapse v-model="activityInfo" class="collapse-box">
        <el-collapse-item class="collapseItem" title="活动信息">
          <!-- 活动计划信息 -->
          <ActivityMaintenanceInformation :data="activity" />
          <!-- 活动提报信息 -->
          <ActivityReportingInformation :data="signData" :activity="activity" :file-list="fileList.actPlanApply" :approveBtnType="approveBtnType" />
        </el-collapse-item>
      </el-collapse>
      <!-- 核销信息 -->
      <el-collapse v-model="collapseNumber" class="collapse-box">
        <el-collapse-item class="collapseItem" title="活动核销信息" name="default">
          <el-form ref="formOne" class="UniformCss" :model="Reimburse" label-width="130px">
            <el-row>
              <!-- <el-col :span="6">
                <el-form-item class="form-item" label="反馈时间" prop="feedBackTime">
                  <a-input v-model="signData.feedBackTime" disabled />
                </el-form-item>
              </el-col> -->

                <el-col :span="8">
                  <el-form-item class="form-item" label="提报审批金额">
                    <a-input v-model="signData.approveApplyCost" disabled  />
                  </el-form-item>
                </el-col>

              <el-col :span="8">
                <el-form-item class="form-item" label="实际时间" prop="actualStartTime">
                  <a-date-picker v-model="signData.actualStartTime" type="date" disabled />
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item class="form-item" label="实际结束时间" prop="actualEndTime">
                  <a-date-picker v-model="signData.actualEndTime" type="date" disabled />
                </el-form-item>
              </el-col> -->
              
              <!-- <el-col :span="6">
                <el-form-item class="form-item" label="核销比例(%)">
                  <el-input-number v-model="signData.thisWriteoffCost" :precision="2" controls-position="right" :min="0" :max="100" :controls="false" style="width: 220px;"/>
                </el-form-item>
              </el-col> -->
              <!-- <el-col :span="6">
                <el-form-item class="form-item" label="核销费用(元)" prop="thisWriteoffCost">
                  <a-input v-model="formattedThisWriteoffCost" disabled />
                </el-form-item>
              </el-col> -->

              <el-col :span="8">
                <el-form-item class="form-item" label="现场订车数" prop="orderQuantity">
                  <a-input v-model="signData.orderQuantity" disabled />
                </el-form-item>
              </el-col>
            </el-row>
              <!-- <el-col>
                  <el-form-item class="form-item" label="活动评分">
                    <el-input-number v-model="formattedThisWriteoffCost" :precision="2" controls-position="right" :min="0" :max="100" :controls="false" style="width: 220px;"/>
                  </el-form-item>
              </el-col> -->
              <!-- <el-col :span="12" /> -->

            <el-row>
              <div class="item-line">审核费用确认明细</div>
              <a-col
                  v-for="f in activityVisibilityMap[getFormByActivity(activity.threeLevelName)]"
                  :key="f"
                  :span="6">
                <el-form-item class="form-item" :label="activityFeeFieldList[f].label">
                  <a-input-number
                      :min="activityFeeFieldList[f].min"
                      v-model="signData[f]"
                      @blur="setZeroIfEmpty(f)"
                      @change="getActualCost"
                      :disabled="isDisabled()"/>
                </el-form-item>
              </a-col>
              <el-col :span="6">
                <el-form-item class="form-item" label="实际执行费用(元)" prop="actualCost" v-show="false">
                  <a-input v-model="signData.actualCost" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item class="form-item" label="核销审核费用(元)" prop="writeoffApproveFee">
                  <a-input v-model="formattedapproveWriteoffCost" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item  class="form-item" label="考评金额(元)" >
                  <a-input title="number"  v-model="this.signData.assessmentCost" disabled></a-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col  :span="6">
                <el-form-item class="form-item" label="开票时间">
                  <el-date-picker
                      style="width:200px"
                      @change="onTimeChange"
                      v-model="invoicingTime"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="-"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <a-col :span="6">
                <el-form-item class="form-item" label="开票数">
                  <a-input
                      v-model="invoicingNumber" disabled>
                  </a-input>
                </el-form-item>
              </a-col>
              <el-col :span="6">
                <el-form-item class="form-item" label="集客实际" >
                  <a-input-number v-model="signData.customerActual" disabled :min="0" :precision="0" placeholder="请输入集客实际数量" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item class="form-item" >
                  <a-button type="link" @click="showCustomerModal">扫码集客数据查看</a-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" style="height: auto">
                <div style="float: left">
                  <el-form-item class="form-item" label="增值税发票:">
                    <el-upload
  class="noneupload"
  action=""
  :on-preview="onPreviewFun"
  :file-list="fileList.planWriteOffVatInvoice"
  :auto-upload="false"
  :show-file-list="false"
  style="display:none"
/>
<ul v-if="fileList.planWriteOffVatInvoice && fileList.planWriteOffVatInvoice.length" class="custom-file-list">
  <li v-for="f in fileList.planWriteOffVatInvoice" :key="f.name">
    <a :href="toFullUrl(f.url)" target="_blank" @click.prevent="openUrl(f.url)">{{ f.name }}</a>
  </li>
</ul>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" style="height: auto">
                <div style="float: left">
                  <el-form-item class="form-item" label="过路费发票:">
                    <el-upload
  class="noneupload"
  action=""
  :on-preview="onPreviewFun"
  :file-list="fileList.planWriteOffTollInvoice"
  :auto-upload="false"
  :show-file-list="false"
  style="display:none"
/>
<ul v-if="fileList.planWriteOffTollInvoice && fileList.planWriteOffTollInvoice.length" class="custom-file-list">
  <li v-for="f in fileList.planWriteOffTollInvoice" :key="f.name">
    <a :href="toFullUrl(f.url)" target="_blank" @click.prevent="openUrl(f.url)">{{ f.name }}</a>
  </li>
</ul>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" style="height: auto">
                <div style="float: left">
                  <el-form-item class="form-item" label="加油费发票:">
                    <el-upload
  class="noneupload"
  action=""
  :on-preview="onPreviewFun"
  :file-list="fileList.planWriteOffFuelInvoice"
  :auto-upload="false"
  :show-file-list="false"
  style="display:none"
/>
<ul v-if="fileList.planWriteOffFuelInvoice && fileList.planWriteOffFuelInvoice.length" class="custom-file-list">
  <li v-for="f in fileList.planWriteOffFuelInvoice" :key="f.name">
    <a :href="toFullUrl(f.url)" target="_blank" @click.prevent="openUrl(f.url)">{{ f.name }}</a>
  </li>
</ul>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" style="height: auto">
                <div style="float: left">
                  <el-form-item class="form-item" label="费用凭证:">
                    <el-upload
  class="noneupload"
  action=""
  :on-preview="onPreviewFun"
  :file-list="fileList.planWriteOffVoucher"
  :auto-upload="false"
  :show-file-list="false"
  style="display:none"
/>
<ul v-if="fileList.planWriteOffVoucher && fileList.planWriteOffVoucher.length" class="custom-file-list">
  <li v-for="f in fileList.planWriteOffVoucher" :key="f.name">
    <a :href="toFullUrl(f.url)" target="_blank" @click.prevent="openUrl(f.url)">{{ f.name }}</a>
  </li>
</ul>
                  </el-form-item>
                </div>
              </el-col>
              
              <el-col :span="24" style="height: auto">
                <div style="float: left">
                  <el-form-item class="form-item" label="合同:">
                    <el-upload
  class="noneupload"
  action=""
  :on-preview="onPreviewFun"
  :file-list="fileList.planWriteOffContract"
  :auto-upload="false"
  :show-file-list="false"
  style="display:none"
/>
<ul v-if="fileList.planWriteOffContract && fileList.planWriteOffContract.length" class="custom-file-list">
  <li v-for="f in fileList.planWriteOffContract" :key="f.name">
    <a :href="toFullUrl(f.url)" target="_blank" @click.prevent="openUrl(f.url)">{{ f.name }}</a>
  </li>
</ul>
                  </el-form-item>
                </div>
              </el-col>
              
              <el-row>
                <el-col :span="24" style="height: auto">
                  <el-form-item label="活动照片:">
                    <el-upload
                        ref="upload"
                        :disabled="true"
                        action="#"
                        :auto-upload="false"
                    >
                      <vxe-button icon="el-icon-view" type="primary" @click="openPicDialog">乘龙图片库</vxe-button>
                      <vxe-button
                          v-if="selectImgInfoList.length > 0"
                          icon="el-icon-download"
                          type="primary"
                          :loading="downLoading"
                          @click="onDownloadPic(0)"
                      >下载图片</vxe-button>
                    </el-upload>
                    <div v-if="selectImgInfoList.length>0" class="pic-box scrollBars">
                      <div v-for=" (item, index) in selectImgInfoList" :key="index" class="image-item2">
                        <el-image
                            style="width: 180px; height:180px;"
                            :src="item.url"
                            :preview-src-list="selectImgInfoList.map(val => val.url)"
                            lazy
                            fit="cover"
                        >
                          <div slot="placeholder" class="image-slot">
                            <i class="el-icon-loading" />
                          </div>
                        </el-image>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>


              <el-col :span="24" style="height: auto">
                <div style="float: left">
                  <el-form-item class="form-item" label="其他材料附件:">
                    <el-upload
  class="noneupload"
  action=""
  :on-preview="onPreviewFun"
  :file-list="fileList.planWriteOffAttachments"
  :auto-upload="false"
  :show-file-list="false"
  style="display:none"
/>
<ul v-if="fileList.planWriteOffAttachments && fileList.planWriteOffAttachments.length" class="custom-file-list">
  <li v-for="f in fileList.planWriteOffAttachments" :key="f.name">
    <a :href="toFullUrl(f.url)" target="_blank" @click.prevent="openUrl(f.url)">{{ f.name }}</a>
  </li>
</ul>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
              
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <!-- 审核历史 -->
      <checkHistory :find-hist-tasks-data="findHistTasksData" :writeoff-task-data="findWriteoffTasksData" />

      <!-- <checkHistory 
      :find-hist-tasks-data="findHistTasksData" 
      :writeoff-task-data="findWriteoffTasksData"
      :sign-data="signData"
      :activity="activity"
    /> -->
    </div>
    <el-dialog title="审批信息" :visible.sync="dialogVisible" width="40%">
      <div v-if="approveTypeName === '转 派'" class="demo-input-suffix" style="padding-bottom: 20px;">
        转派人：
        <el-input v-model="operatorUser" placeholder="请选择转派的用户" style="width:35%" @focus="chooseUser" />
      </div>
      <div v-if="approveTypeName === '同 意'" class="demo-input-suffix" style="padding-bottom: 20px;">
        审核金额：
        <!-- <el-input-number v-model="approveCost" :precision="2" controls-position="right" :step="0.1" :min="0.00" :max="9000000000000" :controls="false" /> -->
        <!-- <el-input v-model="approveCost" maxlength="13" style="width:35%" oninput="value=value.replace(/\D/g, '')" /> -->
        <!-- <el-input-number v-model="approveCost" :precision="2" controls-position="right" :step="0.1" :min="0.00" :max="9000000000000" :controls="false" /> -->
        <el-input-number 
  v-model="approveCost" 
  :precision="2" 
  controls-position="right" 
  :step="0.1" 
  :min="0.00" 
  :max="calculateMaxApproveCost()" 
  :controls="false" 
  :disabled="!isDisabled()"
/>
      </div>
      <div v-if="approveTypeName === '同 意' && JSON.stringify(this.permissions).includes('kaoping')" class="demo-input-suffix" style="padding-bottom: 20px;">
        考评金额：
        <el-input-number v-model="assessmentCost" :precision="2" lable='考评金额' controls-position="right" :step="0.1"  placeholder="请输入考评金额（正数奖励，负数扣罚）" :controls="false" />
        <!-- <a-input title="number" v-if="JSON.stringify(this.permissions).includes('kaoping')" v-model="assessmentCost" placeholder="请输入考评金额（正数奖励，负数扣罚）" style="text-align: left; width: 300px"></a-input> -->
        <p v-if="errorMessage" style="color: red;">{{ errorMessage }}</p>
      </div>
      <div v-if="approveTypeName === '同 意'" class="demo-input-suffix" style="padding-bottom: 20px;">
        结算金额：
        <el-input-number v-model="settlementAmount" disabled :precision="2" controls-position="right" :controls="false"  style="width: 180px; background-color: #f5f7fa;" />
      </div>
      <el-input
        v-model="approveMsg"
        type="textarea"
        placeholder="请输入审批意见"
        maxlength="300"
        show-word-limit
      />
      <span slot="footer" class="dialog-footer">
        <vxe-button :loading="approveBtnLoading" type="primary" @click="approve()">{{ approveTypeName }}</vxe-button>
        <vxe-button @click="dialogVisible = false">取 消</vxe-button>
      </span></el-dialog>

    <el-dialog title="选择用户" :visible.sync="userDialogVisible" width="75%">
      <div style="margin-bottom: 20px">
        <el-input v-model="userName" placeholder="输入用户名称" clearable :style="{ width: '80%' }" @change="handleFilter" />
        <vxe-button type="primary" icon="el-icon-search" class="filter-search-item" style="float: right" @click="handleFilter">查询</vxe-button>
      </div>
      <vxe-table
        ref="Xuser"
        border
        show-header-overflow
        show-overflow
        :column-config="{ resizable: true }"
        stripe
        round
        :loading="userLoading"
        max-height="350"
        align="center"
        :scroll-y="{ enabled: false }"
        :data="userLists"
        :reserve="true"
        :row-config="{ isCurrent: true, isHover: true }"
        :radio-config="{ strict: false, labelField: 'seq', trigger: 'row', isCurrent: true, isHover: true }"
      >
        <vxe-column type="radio" width="60" />
        <vxe-column :visible="false" field="id" title="用户id" />
        <vxe-column type="seq" title="序号" width="60" />
        <vxe-column field="name" title="用户名称" width="110" />
        <!-- <vxe-column field="roleNames" title="角色" /> -->
        <vxe-column field="department" title="所属组织结构" />
      </vxe-table>
      <vxe-pager
        :loading="userLoading"
        :current-page="addTablePage.currentPage"
        :page-size="addTablePage.pageSize"
        :total="addTablePage.totalResult"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="handlePageChange"
      />
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="userDialogVisible = false">取 消</vxe-button>
        <vxe-button type="primary" @click="handleChooseUser()">确 定</vxe-button>
      </span>
    </el-dialog>

    <el-dialog title="乘龙图片库" :visible.sync="PictureBase.OutBox" :close-on-click-modal="false" width="45%">
      <div v-if="allImgInfoList.length > 0">
        <vxe-button
          type="primary"
          icon="el-icon-download"
          style="margin:0 0 10px 10px;"
          :loading="downLoading"
          @click="onDownloadPic(1)"
        >下载图片</vxe-button>
        <div class="picDialog scrollBars">
          <div v-for="item in allImgInfoList" :key="item.id" class="image-item">
            <div class="img">
              <el-image
                style="width: 180px; height: 180px;"
                :preview-src-list="allImgInfoList.map(item => item.url)"
                :src="item.url"
                fit="cover"
                lazy
              >
                <div slot="placeholder" class="image-slot">
                  <i class="el-icon-loading" />
                </div>
              </el-image>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="null-tip">
        暂无图片
      </div>
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="PictureBase.OutBox = false" status="primary">关 闭</vxe-button>
      </span>
    </el-dialog>

    <!-- 扫码集客详情弹窗 -->
    <el-dialog title="客户详情" :visible.sync="customerModalVisible" :close-on-click-modal="false" width="80%" top="5vh">
      <div style="height: 60vh; overflow: auto;">
        <vxe-table
            :data="customerList"
            :loading="customerLoading"
            border
            stripe
            height="100%"
            :scroll-y="{enabled: true}"
        >
          <vxe-column type="seq" title="序号" width="60" />
          <vxe-column field="actCode" title="活动提报编号"/>
          <vxe-column field="customerName" title="客户姓名"/>
          <vxe-column field="mobile" title="手机号"/>
          <vxe-column field="createTime" title="扫码时间"/>
        </vxe-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="customerModalVisible = false" status="primary">关 闭</vxe-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import waves from '@/directive/waves' // waves directive
import ActivityMaintenanceInformation from '../MarketActivityComponents/ActivityMaintenanceInformation.vue'
import ActivityReportingInformation from '../MarketActivityComponents/ActivityReportingInformation.vue'
import checkHistory from '../components/checkHistory.vue'
import { setInitImg } from '@/utils/Picture/transferFile'
import { findDealerActById, getActApplyDetail, getFiles, saveApproveInfo, findFileInfo, getCameraPictures,getCarInvoiceCount,actCustomerListByActCode } from '@/api/actPlan.js'
import { approveStart, approveExecute, executeLastNode, executeAndJumpFirst, findTaskInfos, transfer, approveRestart, findDisTaskInfos } from '@/api/wf_process.js'
import { findList } from '@/api/user'
import { mapGetters } from 'vuex'
import { dateFormat } from '@/utils/DateUtils'
import { toThousandNumFilter } from '@/filters/index.js'
//import { getRemainFee } from '@/api/amount'
import JSZip from 'jszip'
import { MessageBox } from 'element-ui'
import {activityFeeFieldList, activityFormMap, activityVisibilityMap} from "@/utils";

const defaultApproveType = new Map([
  [0, '发起审批'],
  [1, '同 意'],
  [2, '退回上一审批人'],
  [3, '驳 回'],
  [4, '转 派'],
  [5, '重新发起审批'],
  [6, '不同意']
])

const defaultListQuery = {
  page: 1,
  limit: 10,
  importance: undefined,
  domain: 'center',
  title: undefined,
  type: undefined,
  conditions: [],
  sort: '+id'
}

const defautFactor = {
  code: '',
  symbol: '',
  values: ''
}

export default {
  name: 'DetailedReimbursement',
  directives: { waves },
  components: {
    ActivityMaintenanceInformation,
    // 活动提报信息
    ActivityReportingInformation,
    // 审核历史
    checkHistory
  },
  data() {
    return {
      errorMessage: '',
      activityInfo:'',
      assessment: 'default',
      baseUrl: process.env.VUE_APP_BASE_API,
      loading: false,
      collapseNumber: 'default',
      activity: {},
      signData: {},
      approveBtnType: '0',
      approveBtnLoading: false,
      listQuery: Object.assign({}, defaultListQuery),
      dialogVisible: false,
      approveMsg: '',
      assessmentCost: '',
      settlementAmount: '',  // 结算金额
      approveCost: '',
      userLists: [],
      userName: '',
      approveTypeName: '',
      userLoading: false,
      operatorUser: '',
      addTablePage: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0
      },
      operatorId: '',
      userDialogVisible: false,
      approveType: defaultApproveType,
      factor: Object.assign({}, defautFactor),
      fileList: {
        actPlanApply: [], // 计划方案
        planWriteOffVatInvoice: [], // 发票
        planWriteOffContract: [], // 合同列表
        planWriteOffTollInvoice: [], // 过路费发票
        planWriteOffVoucher: [], // 费用凭证列表
        planWriteOffAttachments: [], // 核销材料附件列表
        planWriteOffFuelInvoice: []  //  加油费
      },
      programmeList: [], // 核销附件
      getActByIdData: {},
      getMarketactivityByIdData: {},
      getCollectqtyByIdData: {},
      findHistTasksData: [],
      findWriteoffTasksData: [],
      Reimburse: {},
      Reimbursekp: {},
      picNames: [],
      fileInfoList: [],
      // 选择风行图片库执行照片上传对话框
      PictureBase: {
        OutBox: false,
        box: false,
        ImageUrl: '',
        disabled: false,
        imgs: [],
        loading: false
      },
      downLoading: false,
      selectImgInfoList: [], // 已选图片信息列表
      allImgInfoList: [], // 全部图片信息列表
      amountData: {
        amountId: null,
        remainFee: null
      },
      officeTypeList: ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'],
      invoicingTime: '', // 开票时间
      invoicingNumber: null,
      currentApprovalNode: "",
      customerModalVisible: false, // 客户详情弹窗控制
      customerList: [], // 客户列表数据
      customerLoading: false, // 客户数据加载状态
    }
  },
  computed: {
    activityFeeFieldList() {
      return activityFeeFieldList
    },
    activityVisibilityMap() {
      return activityVisibilityMap
    },
    // ...mapGetters(['userinfo']),
    // ...mapGetters('account', ['user','nd']),
    ...mapGetters('account', ['user','permissions', 'roles']),
// 组件中

  // permissions() {
  //   return this.$store.state.permissions;
  // },
  //   formattedActualCost() {
  //     if (this.signData.actualCost !== null) {
  //       return toThousandNumFilter(this.signData.actualCost)
  //     } else {
  //       return '' // 或者其他你希望显示的默认值
  //     }
  //   },
    // formattedThisWriteoffCost() {
    //   if (this.signData.actualCost !== null) {
    //     return toThousandNumFilter(this.signData.thisWriteoffCost)
    //   } else {
    //     return '' // 或者其他你希望显示的默认值
    //   }
    // }
    formattedapproveWriteoffCost() {
      if (this.signData.approveWriteoffCost !== null) {
        return toThousandNumFilter(this.signData.approveWriteoffCost)
      } else {
        return '' // 或者其他你希望显示的默认值
      }
    }
  },
  watch: {
    approveCost(newVal) {
      this.calculateSettlementAmount();
      const maxAllowed = this.calculateMaxApproveCost();
      if (newVal > maxAllowed) {
        this.errorMessage = `审核金额不能大于核销比例*提报审批金额 (${maxAllowed.toFixed(2)} 元)`;
      } else {
        this.errorMessage = '';
      }
    },
    // approveCost(newVal) {
    //   const maxAllowed = this.activity.feeLimit * (this.activity.writeRate / 100);
    //   if (newVal > maxAllowed) {
    //     this.errorMessage = '审核金额不能大于费用额度*核销比例';
    //   } else {
    //     this.errorMessage = '';
    //   }
    // },
    assessmentCost(newVal) {
      console.log('考评金额变化:', newVal);
      this.calculateSettlementAmount();
    },
    dialogVisible(val) {
      if (!val) {
        this.operatorId = ''
        this.operatorUser = ''
        this.approveMsg = ''
        this.approveBtnLoading = false
      } else {
        this.approveCost = this.signData.approveWriteoffCost
        this.assessmentCost = this.signData.assessmentCost
        this.calculateSettlementAmount()
      }
    }
  },
  async created() {
    if (this.$route.params.id) {
      this.signData.id = this.$route.params.id
      // 获取提报详情
      this.getMarketactivityById(this.$route.params.id)
      // 这个动作通常用于从后端API获取权限数据，并存储在Vuex的状态管理中
       this.$store.dispatch("fetchPermissions");
      // 打印每个权限对象的详细信息
      console.log('权限'+JSON.stringify(this.permissions))
      }// 在 created 或 mounted 钩子中添加这行代码
    },
  methods: {
    // 结算金额计算
    calculateSettlementAmount() {
      const approveCost = parseFloat(this.approveCost) || 0;
      const assessmentCost = parseFloat(this.assessmentCost) || 0;
      const settlement = approveCost + assessmentCost;
      this.settlementAmount = settlement.toFixed(2);
    },
    showCustomerModal() {
      this.customerModalVisible = true;
      this.loadCustomerList();
    },
    // 加载客户列表数据
    loadCustomerList() {
      this.customerLoading = true;
      const params = {
        actCode: this.signData.planApplyCode,
        page: 1,
        limit: 1000,
      };
      actCustomerListByActCode(params).then(res => {
        this.customerLoading = false;
        if (res.code === 1 && res.data) {
          this.customerList = res.data.list || res.data || [];
        } else {
          this.$message.error(res.message || '获取扫码客户数据失败');
          this.customerList = [];
        }
      }).catch(error => {
        this.customerLoading = false;
        this.$message.error('获取扫码客户数据失败');
        this.customerList = [];
        console.error('扫码客户数据加载错误:', error);
      });
    },
    // 获取集客实际数据数量
    getCustomerActualCount() {
      const params = {
        actCode: this.signData.planApplyCode,
        page: 1,
        limit: 1,
      };

      actCustomerListByActCode(params).then(res => {
        if (res.code === 1 && res.data) {
          const total = res.data.total || 0;
          this.$set(this.signData, 'customerActual', Number(total));
        }
      }).catch(error => {
        console.error('获取集客数据失败:', error);
        this.$set(this.signData, 'customerActual', 0);
      });
    },
    //查询开票数量
    async onTimeChange() {
      const params = {
        kpsjBegin: this.invoicingTime[0],
        kpsjEnd: this.invoicingTime[1],
        orgid: this.activity.dealerId
      };
      const res = await getCarInvoiceCount(params)
      this.invoicingNumber = res.data
    },
    calculateMaxApproveCost() {
    if (this.activity && this.activity.writeRate && this.signData && this.signData.approveApplyCost) {
      const writeRate = parseFloat(this.activity.writeRate) || 0;
      const approveApplyCost = parseFloat(this.signData.approveApplyCost) || 0;
      return (writeRate / 100) * approveApplyCost;
    }
    return 9000000000000; // 默认最大值
  },
  toFullUrl(url) {
    if (!url) return '';
    const abs = /^https?:\/\//i.test(url);
    if (abs) return url;
    const base = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/+$/,'');
    const path = String(url).replace(/^\/+/, '');
    return base ? base + '/' + path : '/' + path;
  },
  openUrl(url) {
    const full = this.toFullUrl(url);
    if (full) window.open(full, '_blank');
  },

    viewDetail() {
      this.showInput = true;
      },
    // 获取提报详情
    getMarketactivityById(id) {
      this.loading = true
      getActApplyDetail(id).then(res => {
        if (res.code === 1 && res.data) {
          this.signData = res.data
          this.signData.dealerName = res.data.dealerName
          this.signData.dealerShortName = res.data.orgName
          this.handleAppBtn()
          this.findWriteoffApprove()
          this.viewApproveDetail()
          this.getActById(this.signData.planDealerId)
          this.getFileInfo()
          this.getPicLibrary()

          if (this.signData.actualCost === null || this.signData.actualCost === '' || this.signData.actualCost === 0) {
            this.getActualCost()
          }

          // 获取扫码数量
          if (this.signData.writeoffStatus === '2' && (this.signData.planApplyCode !== null || this.signData.planApplyCode !== '')) {
            this.getCustomerActualCount()
          }

          this.loading = false
        } else {
          this.$message.error(res.message)
          this.loading = false
        }
      })
    },
    // 获取文件名
    getFileInfo() {
      findFileInfo(this.signData.planApplyCode).then(res => {
        if (res.code === 1 && res.data) {
          this.fileInfoList = res.data
          this.initFile()
        }
      })
    },
    // initFile() {
    //   if (this.fileInfoList.length < 1) {
    //     return
    //   }
    //   this.fileInfoList.forEach(item => {
    //     const file = {
    //       name: item.name,
    //       url: item.url
    //     }
    //     this.fileList[item.module].push(file)
    //     // getFiles(item).then(res => {
    //     //   const file = setInitImg(res, item.name)
    //     //   this.fileList[item.module].push(file)
    //     // })
    //   })
    // },

    initFile() {
  if (this.fileInfoList.length < 1) {
    return
  }
  const baseUrl = process.env.VUE_APP_API_BASE_URL + '/'
  this.fileInfoList.forEach(item => {
    const file = {
      name: item.name,
      url: baseUrl + item.url  // 拼接完整URL
    }
    this.fileList[item.module].push(file)
  })
},

    // 获取图片信息
    getPicLibrary() {
      this.allImgInfoList = []
      this.selectImgInfoList = []
      const data = { planApplyCode: this.signData.planApplyCode }
      getCameraPictures(data).then(res => {
        if (res.code === 1 && res.data) {
          this.allImgInfoList = res.data
          this.getImagesUrl()
        }
      })
    },
    // 拼接图片url
    getImagesUrl() {
      this.allImgInfoList.forEach(item => {
        // item.url = this.baseUrl + '/ACTIVITY-SERVE/act-plan-apply/getFileByte2?path=' + item.path
        if (item.isSelect === '1') {
          this.selectImgInfoList.push(item)
        }
      })
    },
    // 打开图片库
    openPicDialog() {
      const checkedCount = this.selectImgInfoList.length
      this.checkAll = checkedCount === this.allImgInfoList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.allImgInfoList.length
      this.PictureBase.OutBox = true
    },
    // 下载全部图片
    async onDownloadPic(type) {
      this.downLoading = true
      let downloadList = []
      let zipName = null
      if (type === 0) {
        downloadList = this.selectImgInfoList
        zipName = this.signData.planApplyCode + '_' + '执行照片(已选)'
      } else {
        downloadList = this.allImgInfoList
        zipName = this.signData.planApplyCode + '_' + '执行照片(全部)'
      }

      // 创建一个新的 JSZip 实例
      const zip = new JSZip()

      // 创建一个 Promise 数组以将图像添加到压缩包
      const promises = downloadList.map((imageInfo) => {
        // console.log(imageInfo.url)
        return fetch(imageInfo.url)
          .then(response => response.blob())
          .then(blob => {
          // 添加图像到压缩包
            zip.file(imageInfo.name, blob)
          })
      })

      // 所有图像处理完成后生成压缩包
      Promise.all(promises)
        .then(() => {
        // 生成压缩包的二进制数据
          return zip.generateAsync({ type: 'blob' })
        })
        .then((blob) => {
        // 创建一个隐藏的<a>元素来下载压缩包
          const downloadLink = document.createElement('a')
          downloadLink.href = URL.createObjectURL(blob)
          downloadLink.download = zipName // 压缩包文件名
          document.body.appendChild(downloadLink)
          downloadLink.click()
          document.body.removeChild(downloadLink) // 清理<a>元素
          this.downLoading = false
        })
        .catch((error) => {
          console.error('Error while creating the zip:', error)
        })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.factor.code = 'nameOrAccount'
      this.factor.values = this.userName
      this.listQuery.conditions[0] = this.factor
      this.findUsers()
    },
    handleAppBtn() {
      if (this.signData.domain === 'dealer' && this.signData.writeoffStatus === '1') {
        this.approveBtnType = '1'
      }
      if (this.signData.writeoffStatus === '2' &&
      this.signData.writeoffAuditorIds.indexOf(this.user.userId) !== -1) {
        this.approveBtnType = '2'
      }
      if (this.signData.domain === 'dealer' && this.signData.writeoffStatus === '4' && this.user.userId === this.signData.writeoffAuditorIds) {
        this.approveBtnType = '3'
      }
    },
    chooseUser() {
      this.userDialogVisible = true
      this.findUsers()
    },
    findUsers() {
      this.userLoading = true
      findList(this.listQuery).then(res => {
        if (res.code === 1 && res.data) {
          this.userLists = res.data.list
          this.addTablePage.totalResult = res.data.total
          this.userLoading = false
        }
      })
    },

        // 提报流程获取
    viewApproveDetail() {
      if (this.signData.applyOrderId || this.signData.applyHistOrderId) {
        const param = {
          orderId: this.signData.applyOrderId || this.signData.applyHistOrderId
        }
        findTaskInfos(param).then(res => {
          if (res.code === 1 && res.data) {
            this.findHistTasksData = res.data
            this.findHistTasksData.forEach(item => {
              if (!item.his) {
                item.operatorName = this.signData.applyAuditorNames
                item.finishTime = '正在处理'
              }
            })
            this.approveAppLoading = false
          }
        })
      }
    },

    // 核销流程获取
    findWriteoffApprove() {
      if (this.signData.writeoffOrderId || this.signData.writeoffHistOrderId) {
        const param = {
          orderId: this.signData.writeoffOrderId || this.signData.writeoffHistOrderId
        }
        if (this.signData.writeoffStatus === '6') {
          findDisTaskInfos(param).then(res => {
            if (res.code === 1 && res.data) {
              this.findWriteoffTasksData = res.data
              console.log(this.findWriteoffTasksData,'lululu')
            }
          })
        } else {
          findTaskInfos(param).then(res => {
            if (res.code === 1 && res.data) {
              this.findWriteoffTasksData = res.data
              this.findWriteoffTasksData.forEach(item => {
                if (!item.his) {
                  item.operatorName = this.signData.writeoffAuditorNames
                  item.finishTime = '正在处理'
                  this.currentApprovalNode = item.taskName
                }
              })
            }
          })
        }
      }
    },
    handlePageChange({ currentPage, pageSize }) {
      this.addTablePage.currentPage = currentPage
      this.addTablePage.pageSize = pageSize
      this.listQuery.limit = pageSize
      this.listQuery.page = currentPage
      this.findUsers()
    },
    handleChooseUser() {
      const data = this.$refs['Xuser'].getRadioRecord()
      if (data) {
        this.operatorUser = data.name
        this.operatorId = data.id
      }
      this.userDialogVisible = false
    },
    approve() {
      //  发起审批
      this.approveBtnLoading = true
      if (this.approveTypeName === '发起审批') {
        if (this.signData.approveApplyCost == 0) {
          MessageBox.confirm('可核销费用为0, 是否继续发起核销?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleAmount(0)
          }).catch(() => {
            this.$message.info('已取消发起核销')
            this.approveBtnLoading = false
          })
        } else {
          this.handleAmount(0)
        }
      }
      // 同意
      if (this.approveTypeName === '同 意') {
        if (this.approveMsg === '') {
          this.approveBtnLoading = false
          this.$message.warning('审批意见不能为空')
          return
        }
        if (this.approveCost === '') {
          this.$message.warning('审核金额不能为空')
          this.approveBtnLoading = false
          return
        }
        // 校验规则更改，20250915
        if (this.approveCost > this.signData.approveApplyCost * (JSON.stringify(this.activity.writeRate/100 ) )){
        // if (this.approveCost > this.activity.feeLimit * (JSON.stringify(this.activity.writeRate/100 ) )){
          this.$message.warning('审核金额不能大于核销比例*提报审批金额 (${maxAllowed.toFixed(2)} 元)')
          this.approveBtnLoading = false
          return
        }
          // if (this.approveCost > this.signData.approveWriteoffCost) {
          // this.$message.warning('审核金额不能大于上一节点审核金额')
          // this.approveBtnLoading = false
          // return
       
        // if (this.approveCost > this.signData.approveApplyCost) {
        //   this.$message.warning('审核金额不能大于上一节点审核金额')
        //   this.approveBtnLoading = false
        //   return
        // }
        this.signData.thisWriteoffCost = this.approveCost
        const approveParam = {
          orderId: this.signData.writeoffOrderId,
          processName: this.signData.activityWriteOffProcessName,  
          args: {
            amounts: this.signData.thisWriteoffCost,
            approveMsg: this.approveMsg,
            approveCost: this.approveCost,
            businessCode: this.signData.planApplyCode,
            businessName: this.signData.planApplyName,
            assessmentCost: this.assessmentCost
          }
        }
        approveExecute(approveParam).then(res => {
          if (res.code === 1) {
            if (res.data.endFlg === true) {
              this.signData.writeoffStatus = '3'
              this.signData.approveWriteoffCost = this.approveCost
              this.signData.writeoffHistOrderId = res.data.orderId
              this.signData.assessmentCost=this.assessmentCost
            } else {
              this.signData.approveWriteoffCost = this.approveCost
              this.signData.writeoffAuditorNames = res.data.operatorInfos[0].operatorNames
              this.signData.writeoffAuditorIds = res.data.operatorInfos[0].operatorIds
              this.signData.writeoffNode = res.data.approveNode
              this.signData.assessmentCost=this.assessmentCost

            }
            saveApproveInfo(this.signData).then(v => {
              this.approveBtnLoading = false
              if (v.code === 1) {
                this.dialogVisible = false  // 关闭审批弹框
                // this.reload()
                this.ReturnFun()
              }else {
                this.$message.error(v.message)
                this.dialogVisible = false  // 关闭审批弹框
              }
            })
          }else {
            this.approveBtnLoading = false
            this.$message.error(res.message)
            this.dialogVisible = false  // 关闭审批弹框
          }
        })
      }
      // 退回上一步
     if (this.approveTypeName === '退回上一审批人') {
        if (this.approveMsg === '') {
          this.approveBtnLoading = false
          this.$message.warning('审批意见不能为空')
          return
        }
        const approveParam = {
          orderId: this.signData.writeoffOrderId,
          args: {
            amounts: this.signData.thisWriteoffCost,
            approveMsg: this.approveMsg,
            businessCode: this.signData.planApplyCode,
            businessName: this.signData.planApplyName
          }
        }
        executeLastNode(approveParam).then(res => {
          if (res.code === 1) {
            this.signData.applyNode = res.data.approveNode
            // 退回第一个节点，和驳回的逻辑一致
            if (res.data.firstNodeFlg === true) {
              this.signData.writeoffStatus = '4'
            }
            this.signData.writeoffAuditorNames = res.data.operatorInfos[0].operatorNames
            this.signData.writeoffAuditorIds = res.data.operatorInfos[0].operatorIds
            this.signData.writeoffNode = res.data.approveNode
            saveApproveInfo(this.signData).then(v => {
              this.approveBtnLoading = false
              if (v.code === 1) {
                this.dialogVisible = false  // 关闭审批弹框
                // this.reload()
                this.ReturnFun()
              }else {
                this.$message.error(v.message)
                this.dialogVisible = false  // 关闭审批弹框
              }
            })
          }else {
            this.approveBtnLoading = false
            this.$message.error(res.message)
            this.dialogVisible = false  // 关闭审批弹框
          }
        })
      }
      // 驳回
      if (this.approveTypeName === '驳 回') {
        if (this.approveMsg === '') {
          this.approveBtnLoading = false
          this.$message.warning('审批意见不能为空')
          return
        }
        const approveParam = {
          orderId: this.signData.writeoffOrderId,
          args: {
            amounts: this.signData.thisWriteoffCost,
            approveMsg: this.approveMsg,
            businessCode: this.signData.planApplyCode,
            businessName: this.signData.planApplyName
          }
        }
        executeAndJumpFirst(approveParam).then(res => {
          if (res.code === 1) {
            this.signData.writeoffStatus = '4'
            this.signData.writeoffAuditorNames = res.data.operatorInfos[0].operatorNames
            this.signData.writeoffAuditorIds = res.data.operatorInfos[0].operatorIds
            this.signData.writeoffNode = res.data.approveNode
            saveApproveInfo(this.signData).then(v => {
              this.approveBtnLoading = false
              if (v.code === 1) {
                this.dialogVisible = false  // 关闭审批弹框
                // this.reload()
                this.ReturnFun()
              }else {
                this.$message.error(v.message)
                this.dialogVisible = false  // 关闭审批弹框
              }
            })
          }else {
            this.approveBtnLoading = false
            this.$message.error(res.message)
            this.dialogVisible = false  // 关闭审批弹框
          }
        })
      }
      // 转派
      if (this.approveTypeName === '转 派') {
        const approveParam = {
          orderId: this.signData.writeoffOrderId,
          operator: this.operatorId,
          args: {
            amounts: this.signData.thisWriteoffCost,
            approveMsg: this.approveMsg,
            businessCode: this.signData.planApplyCode,
            businessName: this.signData.planApplyName
          }
        }
        transfer(approveParam).then(res => {
          if (res.code === 1) {
            this.signData.writeoffAuditorNames = res.data.operatorInfos[0].operatorNames
            this.signData.writeoffAuditorIds = res.data.operatorInfos[0].operatorIds
            this.signData.writeoffNode = res.data.approveNode
            saveApproveInfo(this.signData).then(v => {
              this.approveBtnLoading = false
              if (v.code === 1) {
                this.dialogVisible = false  // 关闭审批弹框
                // this.reload()
                this.ReturnFun()
              }else {
                this.$message.error(v.message)
                this.dialogVisible = false  // 关闭审批弹框
              }
            })
          }else {
            this.approveBtnLoading = false
            this.$message.error(res.message)
            this.dialogVisible = false  // 关闭审批弹框
          }
        })
      }
      // 不同意
      if (this.approveTypeName === '不同意') {
        if (this.approveMsg === '') {
          this.approveBtnLoading = false
          this.$message.warning('审批意见不能为空')
          return
        }
        const approveParam = {
          orderId: this.signData.writeoffOrderId,
          disagree: '1',
          processName: this.signData.activityWriteOffProcessName,  
          args: {
            amounts: this.signData.thisWriteoffCost,
            approveMsg: this.approveMsg,
            approveCost: this.approveCost,
            businessCode: this.signData.planApplyCode,
            businessName: this.signData.planApplyName
          }
        }
        approveExecute(approveParam).then(res => {
          if (res.code === 1) {
            this.approveBtnLoading = false
            this.signData.writeoffStatus = '6'
            this.signData.approveWriteoffCost = this.approveCost
            this.signData.writeoffHistOrderId = res.data.orderId
            saveApproveInfo(this.signData).then(v => {
              this.approveBtnLoading = false
              if (v.code === 1) {
                this.dialogVisible = false  // 关闭审批弹框
                // this.reload()
                this.ReturnFun()
              }else {
                this.$message.error(v.message)
                this.dialogVisible = false  // 关闭审批弹框
              }
            })
          }else {
            this.approveBtnLoading = false
            this.$message.error(res.message)
            this.dialogVisible = false  // 关闭审批弹框
          }
        })
      }
      // 驳回后重新发起流程
      if (this.approveTypeName === '重新发起审批') {
        if (this.signData.approveApplyCost == 0) {
          MessageBox.confirm('可核销费用为0, 是否继续发起核销?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleAmount(1)
          }).catch(() => {
            this.$message.info('已取消发起核销')
            this.approveBtnLoading = false
          })
        } else {
          this.handleAmount(1)
        }
      }
    },
    // 先获取账期再发起流程，type：0正常发起，1重新发起
    handleAmount(type) {
      // 判断该预算类型是否已配置流程
      this.$store.dispatch('SelectData/QuerySelect', ['writeOffProcessMap']).then(v => {
        const obj = v.writeOffProcessMap.find(item => item.code === this.activity.budgetTypeCode)
        if (!obj) {
          this.$message.error('该预算类型未配置核销审批流')
          return
        }
        // 日常推广和新入网
        /*
        if (this.activity.budgetTypeCode === '1' || this.activity.budgetTypeCode === '13') {
          // 获取账期
          const data = {
            applyPlanId: this.signData.id,
            budgetType: this.activity.budgetTypeCode
          }
          getRemainFee(data).then(res => {
            if (res.code === 1) {
              this.amountData = res.data
              if (type === 0) {
                this.approveStartFun(obj)
              } else {
                this.approveRestartFun()
              }
            } else {
              this.$message.error(res.message)
            }
          })
        } else { */
          if (type === 0) {
            this.approveStartFun(obj)
          } else {
            this.approveRestartFun()
          }
        //}
      })
    },
    approveStartFun(obj) {
      this.approveCost = this.signData.approveWriteoffCost
      const approveParam = {
        processName: obj.value,
        args: {
          amounts: this.signData.thisWriteoffCost,
          approveMsg: this.approveMsg,
          approveCost: this.approveCost,
          businessCode: this.signData.planApplyCode,
          businessName: this.signData.planApplyName
        }
      }
      approveStart(approveParam).then(res => {
        if (res.code === 1) {
          this.signData.amountId = this.amountData.amountId
          this.signData.writeoffOrderId = res.data.orderId
          this.signData.writeoffNode = res.data.approveNode
          this.signData.writeoffFlowStartTime = dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
          this.signData.writeoffStatus = '2'
          this.signData.approveWriteoffCost = this.approveCost
          this.signData.writeoffAuditorNames = res.data.operatorInfos[0].operatorNames
          this.signData.writeoffAuditorIds = res.data.operatorInfos[0].operatorIds
          saveApproveInfo(this.signData).then(v => {
            this.approveBtnLoading = false
            if (v.code === 1) {
              this.dialogVisible = false  // 关闭审批弹框
              // this.reload()
              this.ReturnFun()
            }else {
              this.$message.error(v.message)
              this.dialogVisible = false  // 关闭审批弹框
            }
          })
        }else {
          this.approveBtnLoading = false
          this.$message.error(res.message)
          this.dialogVisible = false  // 关闭审批弹框
        }
      })
    },
    // 重新发起
    approveRestartFun() {
      this.approveCost = this.signData.approveWriteoffCost
      const approveParam = {
        orderId: this.signData.writeoffOrderId,
        args: {
          amounts: this.signData.thisWriteoffCost,
          approveMsg: this.approveMsg,
          approveCost: this.approveCost,
          businessCode: this.signData.planApplyCode,
          businessName: this.signData.planApplyName
        }
      }
      this.approveBtnLoading = true
      approveRestart(approveParam).then(res => {
        if (res.code === 1) {
          this.signData.writeoffStatus = '2'
          this.signData.approveWriteoffCost = this.approveCost
          // this.signData.writeoffFlowStartTime = dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
          this.signData.writeoffNode = res.data.approveNode
          this.signData.writeoffAuditorNames = res.data.operatorInfos[0].operatorNames
          this.signData.writeoffAuditorIds = res.data.operatorInfos[0].operatorIds

          saveApproveInfo(this.signData).then(v => {
              this.approveBtnLoading = false
            if (v.code === 1) {
              this.dialogVisible = false  // 关闭审批弹框
              // this.reload()
              this.ReturnFun()
            }else {
              this.$message.error(v.message)
              this.dialogVisible = false  // 关闭审批弹框
            }
          })
        }else {
          this.approveBtnLoading = false
          this.$message.error(res.message)
          this.dialogVisible = false  // 关闭审批弹框
        }
      })
    },
    handleApprove(type) {
      this.approveTypeName = this.approveType.get(type)
      this.dialogVisible = true
    },
    // 获取活动详情
    getActById(id) {
      const data = {
        id: id,
        planApplyId: this.signData.id
      }
      findDealerActById(data).then(res => {
        if (res.code === 1 && res.data) {
          this.activity = res.data
          console.log(this.activity,'activity1111')
          console.log(this.activity.writeRate,'activity1111')
          console.log(JSON.stringify(this.activity),'activity222222')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 获取文件
    initFiles() {
      this.fileNames.forEach(name => {
        const data = { fileName: name }
        getFiles(data).then(res => {
          const file = setInitImg(res, name)
          this.fileList.push(file)
          this.saveLoad = false
        })
      })
    },

    
    // 点击下载文件
    // async onPreviewFun(e) {
    //   let pathUrl = process.env.VUE_APP_API_BASE_URL + '/'
    //   console.log(pathUrl + e.url,e,'---e-----');
    //   if (e.url) {
    //       window.open(pathUrl + e.url, '_blank')
    //     // }
    //   } else {
    //     this.exportExcelData(e.raw, e.name)
    //   }
    // },

    async onPreviewFun(e) {
  console.log('onPreviewFun called with:', e)
  console.log('File object:', e)
  console.log('File URL:', e.url)
  console.log('File name:', e.name)
  console.log('Base URL:', process.env.VUE_APP_API_BASE_URL)
  
  let pathUrl = process.env.VUE_APP_API_BASE_URL + '/'
  const fullUrl = (e.url || '').startsWith('http') ? e.url : pathUrl + e.url
  console.log('Full path URL:', fullUrl)  
  if (e.url) {
    const fileName = e.name
    const suffix = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase()
    
    // 压缩文件类型列表
    const archiveTypes = ['rar', 'zip', '7z', 'tar', 'gz']
    
    if (archiveTypes.includes(suffix)) {
      // 压缩文件直接下载
      const downloadLink = document.createElement('a')
      downloadLink.href = fullUrl
      downloadLink.download = fileName
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    } else if (this.officeTypeList.includes(suffix)) {
      // Office文件特殊处理（原有的逻辑）
      const routeData = this.$router.resolve({
        query: { name: e.name, url: e.url },
        path: '/previewFile'
      })
      window.open(routeData.href, '_blank')
    } else {
      // 其它类型直接打开
      window.open(fullUrl, '_blank')
    }
  } else {
    // 未上传文件
    this.exportExcelData(e.raw, e.name)
  }
} ,



    // 二进制流下载 res 流 name 文件名
    exportExcelData(res, name) {
      // 拿到流 设置格式
      var blob = new Blob([res], { type: 'application/msword,charset=utf-8' })
      // 兼容ie
      if (window.navigator.msSaveOrOpenBlob) {
        // IE 下载文件
        navigator.msSaveBlob(blob, NamedNodeMap)
      } else {
        // 创建a标签
        let ele = document.createElement('a')
        // 通过URL.createObjectURL(blob)可以获取当前文件的一个内存URL 设置下载文件的url地址
        ele.setAttribute('href', URL.createObjectURL(blob))
        // 给a标签设置下载按钮
        ele.setAttribute('download', name)
        // 点击下载开始
        ele.click()
        // 收尾
        ele = null
      }
    },
    // 返回
    ReturnFun() {
      if(this.$route.query.type === 'myToDolistShiChangHeXiao'){
        // 跳转路由
        this.$closePage('/terminalActivity/signDetails', '/terminalActivity/myToDolist')
      }else {
        this.$closePage('/terminalActivity/detailedReimbursement', '/terminalActivity/activityReimbursement')
      }
    },
    getActualCost() {
      this.signData.actualCost = Number(this.signData.actualConferenceFee) + Number(this.signData.actualFuelCost)
          + Number(this.signData.actualToll) + Number(this.signData.actualGiftFee) + Number(this.signData.actualMoveInFee) + Number(this.signData.actualMakeCost)
          + Number(this.signData.actualSiteRent) + Number(this.signData.actualAnnualFee) + Number(this.signData.actualOtherFee)

      const actual = Number(this.signData.actualCost) || 0
      const rate = (this.activity.writeRate || 0) / 100
      const apply = Number(this.signData.approveApplyCost) || 0
      if (actual > apply){
        this.signData.approveWriteoffCost = apply * rate
      } else {
        this.signData.approveWriteoffCost = actual * rate
      }
    },
    // 失焦时为空则变0
    setZeroIfEmpty(f) {
      if (this.signData[f] === null || this.signData[f] === undefined || this.signData[f] === '') {
        this.$set(this.signData, f, 0);   // 保证响应式
      }
    },
    isDisabled() {
      if ((this.currentApprovalNode === "actReimburseFirstReviewForSP" || this.currentApprovalNode === "actReimburseSecondReviewForSP"
          || this.currentApprovalNode === "actReimburseFirstReviewForRegular" || this.currentApprovalNode === "actReimburseSecondReviewForRegular"
          || this.currentApprovalNode === "actReimburseFirstReviewForDM" || this.currentApprovalNode === "actReimburseSecondReviewForDM"
          || this.currentApprovalNode === "actReimburseFirstReviewForCF"
          || this.currentApprovalNode === "actReimburseFirstReviewForCT"
          || this.currentApprovalNode === "actReimburseFirstReviewForKAD"
          || this.currentApprovalNode === "CustomerWriteoffFirst")
          && this.approveBtnType === '2'
      ){
        // 1、专项推广（专项推广）:互动营销初审，互动营销复审
        // 2、常规活动（窝子活动）:互动营销初审，互动营销复审
        // 3、数字营销:互动营销初审，互动营销复审
        // 4、卡友关怀（关怀基金）:互动营销初审
        // 5、渠道培训（渠道开发）：战略客户部初审
        // 6、大客户开发（行业客户开发）：战略客户部初审
        // 7、客户运营：客户运营报账初审
        return false;
      }
      return true;
    },
    // 使用这个映射来通过活动类型获取使用的表单
    getFormByActivity(activityType) {
      // 遍历映射对象
      for (const form in activityFormMap) {
        // 检查活动类型是否在当前表单类型的数组中
        if (activityFormMap[form].includes(activityType)) {
          return form;
    }
  }
      // 如果没有找到对应的表单，返回"未知表单"
      return "form1";
    },
  }
}
</script>
<style lang="less">
.item-line {
  padding: 0px 20px;
  width: 100%;
  margin: 0;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
  margin-bottom: 10px;
}
.noneupload {
  width: 80% !important;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #b5b5b5;
    border-radius: 20px;
  }
  .el-table__body-wrapper {
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background: #b5b5b5;
      border-radius: 20px;
      width: 200px;
    }
  }
}
.ActivityPlanReviewExamine {
  // padding: 10px 20px 20px;
  .budgetBox {
    margin: 0 0 20px;
    padding: 10px 10px 20px;
    border: 1px solid #cccccc;
  }
  .blueTitle {
    height: 30px;
    background: #0a76a4;
    padding: 6px 30px;
    margin: 10px 0 0;
    color: white;
  }
}
.noneupload {
  .el-upload--picture-card {
    display: none;
  }
}
.collapseItem {
  .el-collapse-item__header {
    padding: 0px 20px;
    width: 100%;
    margin: 0;
    background: #0a76a4;
    color: #ffffff;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
  }
  .el-collapse-item__content {
    padding-top: 20px;
    padding-right: 20px;
  }
}
.CertificateReleaseApplicationBox {
  width: 100%;
  overflow: auto;
  // padding: 0 5px;
  .elcolSpan {
    font-size: 12px;
    color: #606266;
    text-align: center;
  }
  .budgetBox {
    margin: 0 0 5px 0;
  }
}
.collapse-box {
  margin-top: 10px;
  border: 1px solid #cccccc;
}
.pic-box {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  height: 210px;
  overflow-y: auto;
}
.picDialog {
  height: 400px;
  overflow-y: auto;
}
.image-item {
  width: 200px;
  height: 200px;
  display: inline-block;
  box-sizing: border-box;
  text-align: center;
  padding-left: 5px;
}
.image-item2 {
  width: 200px;
  height: 200px;
  display: inline-block;
  box-sizing: border-box;
  padding: 5px;
  text-align: center;
}
.custom-file-list {
  margin: 0;
  padding: 0;
  list-style: none;
  line-height: 24px;
  position: relative;
}
.custom-file-list a {
  position: relative;
  z-index: 10;
  pointer-events: auto;
  cursor: pointer;
  text-decoration: none;
  color: #409EFF; /* element primary color */
}
.custom-file-list a:hover {
  text-decoration: underline;
}
</style>
 